import bsGetCapis from '../BsGetcapis'
import ajax from '../BsAjax'

// 通过链接上拼的id 获取对应 渠道包下载链接
function getInfo(data) {
  return ajax.get(bsGetCapis + '/web/cmsprod/app/configure/getInfo', {
        params: data
    }
  ).then(res => res.data)
}

export {
    getInfo
}
